<template>
  <ChartCard>
    <ChartHeader label>
      <v-skeleton-loader
        type="text"
        min-width="100%"
        height="20px"
      />
    </ChartHeader>
    <DpplSkeletonLoader>
      <DpplSvg file-name="race-distribution-skeleton" />
    </DpplSkeletonLoader>
  </ChartCard>
</template>

<script setup>
import ChartCard from '@/components/insights/Chart/ChartCard.vue';
import ChartHeader from '@/components/insights/Chart/ChartHeader.vue';
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
</script>

<style lang="less" scoped>
:deep(.v-skeleton-loader__text) {
  margin: 0 !important;
}
</style>
